export default __webpack_public_path__ + "static/media/favicon.21af77cf.ico";